import { render, staticRenderFns } from "./NewCoverages.vue?vue&type=template&id=07cd3123"
import script from "./NewCoverages.vue?vue&type=script&lang=js"
export * from "./NewCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports